import {
  axios,
  List,
  PercentTypeList,
  SignedList,
  HotelAuxList,
  CouponAuxList,
  RateAuxList,
  FidelizationCouponAuxList,
  CouponTypeId,
  EnvironmentDataAuxList,
  ZoneAuxList
} from 'src/api'
import { withAbortController } from 'src/types/withAbortController.type'

export interface ApiGetCouponDataParamsData {
  userToken: string
  environmentDataId: string
}

export interface ApiGetCouponDataParams extends withAbortController {
  serverPath: string
  data: ApiGetCouponDataParamsData
}

export interface ApiGetCouponDataResponse {
  type: string
  errorList: any[]
  ok: boolean
  status: string
  statusType: string
  couponTypeList: List[]
  percentTypeList: PercentTypeList[]
  signedList: SignedList[]
  hotelAuxList: HotelAuxList[]
  couponAuxList: CouponAuxList[]
  rateAuxList: RateAuxList[]
  fidelizationCouponAuxList: FidelizationCouponAuxList[]
  environmentDataAuxList: EnvironmentDataAuxList[]
  zoneAuxList: ZoneAuxList[]
}

export const apiGetCouponData = async (
  {
    serverPath,
    data,
    controller
  }:ApiGetCouponDataParams):Promise<ApiGetCouponDataResponse> => {
  const res = await axios.post<ApiGetCouponDataResponse>(`https://${serverPath}/sialdPMS/web/resourcescrossorigin/coupon/getcoupondata`, data, {
    signal: controller?.signal
  })
  const resData = res.data
  return {
    ...resData,
    fidelizationCouponAuxList: resData.fidelizationCouponAuxList.map(coupon => ({
      ...coupon, couponTypeId: CouponTypeId.LOYALTY
    }))
  }
}
